import React, { Fragment, useEffect } from "react"
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const NotikMe = ({})=> {

  const currentUser = security.currentUserValue;
  const apikey      = 'at9d5afhJB2227CmJDKESeikcczf1w2L';
  const pubId       = 'bEUv'
  const appId       = 's6tGv4liKT'

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />
      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        scrolling="yes"
        frameBorder="0"
        src={`https://notik.me/coins?api_key=${apikey}&pub_id=${pubId}&app_id=${appId}&user_id=${currentUser.id}`}
      ></iframe>
    </Fragment>
  );
};

export default NotikMe;
